import { Button, makeStyles, tokens } from '@fluentui/react-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/TeamsAuthProvider';
import { buildNavItems } from '../../utils/access';

// The "View As" banner + trigger used to live here, but AppNav wasn't
// rendered on every route (Queues/Company used to render the BrandHeader
// hero instead), which let an admin navigate there while emulating with no
// safety indicator and no Exit button. It now renders once at app level
// (see App.tsx) so it's present on every route. See
// PlatformEmulationControl.tsx for the component itself.
//
// Desktop button-row presentation of the single nav item list (spec §4.2),
// rendered inside PageHeader's title row on every route. PageHeader's own
// Drawer renders the same `buildNavItems(user)` list for the mobile/hamburger
// presentation -- see utils/access.ts for the one source of truth (fixes F7,
// the two disagreeing nav lists).

const useStyles = makeStyles({
  nav: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalS,
    marginBottom: tokens.spacingVerticalL,
  },
});

export function AppNav() {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  const items = buildNavItems(user);

  return (
    <div className={styles.nav}>
      {items.map((item) => (
        <Button
          key={item.path}
          appearance={location.pathname.startsWith(item.path) ? 'primary' : 'secondary'}
          onClick={() => navigate(item.path)}
        >
          {item.label}
        </Button>
      ))}
    </div>
  );
}
